import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Button, Typography, Box, Grid, CircularProgress } from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const LanguagesSelection = ({ userId }) => {
    const [languages, setLanguages] = useState([]); // List of available languages
    const [selectedLanguages, setSelectedLanguages] = useState([]); // Selected languages
    const [loading, setLoading] = useState(true); // For loading state
    const [error, setError] = useState(null); // For error handling
    const [submitted, setSubmitted] = useState(false); // To track if user has submitted

    useEffect(() => {
        axios.get(`${API_URL}/api/languages/`)  // No user_id needed to get all languages
            .then(response => {
                setLanguages(response.data || []);
                setLoading(false);
            })
            .catch(err => {
                setError("Error fetching languages.");
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (userId) {
            axios.get(`${API_URL}/api/user_languages/`, {
                params: { user_id: userId }  // Pass user_id as a query parameter
            })
                .then(response => {
                    const selected = response.data.languages || [];
                    setSelectedLanguages(selected);
                    if (selected.length > 0) {
                        setSubmitted(true);
                    }
                })
                .catch(err => {
                    setError("Error fetching user's selected languages.");
                });
        }
    }, [userId]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        setSelectedLanguages(prevSelected => {
            if (checked) {
                return [...prevSelected, value];
            } else {
                return prevSelected.filter(language => language !== value);
            }
        });
    };

    const handleSubmit = () => {
        axios.patch(`${API_URL}/api/user_languages/update/`, {
            user_id: userId,  // Pass user_id in request body
            languages: selectedLanguages
        })
            .then(response => {
                setSubmitted(true);
                alert("Languages updated successfully!");
            })
            .catch(err => {
                alert("Error updating languages.");
            });
    };

    if (loading) {
        return <CircularProgress sx={{ color: '#ff8c00' }} />;
    }

    if (error) {
        return <Typography sx={{ color: '#ff4444', textAlign: 'center', fontSize: '1rem' }}>{error}</Typography>;
    }

    return (
        <Box sx={{ backgroundColor: '#000000', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 3 }}>
            <Typography sx={{ fontSize: '2rem', marginBottom: 3, textAlign: 'center', color: '#e0e0e0', letterSpacing: 5 }}>
                {submitted ? 'Your Selected Languages' : 'Select Your Languages'}
            </Typography>

            {submitted ? (
                <Box>
                    <Typography variant="h6" sx={{ color: '#e0e0e0', marginBottom: 2, letterSpacing: 4 }}>
                        Your selected languages are:
                    </Typography>
                    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                        {languages.map((language, index) => (
                            <Grid item xs={12} key={index}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            value={language.name}
                                            onChange={handleCheckboxChange}
                                            checked={selectedLanguages.includes(language.name)}
                                            sx={{
                                                color: '#ffffff',
                                                '&.Mui-checked': { color: '#ff8c00' },
                                                '&:hover': { backgroundColor: 'rgba(255, 140, 0, 0.1)' },
                                            }}
                                        />
                                    }
                                    label={language.name}
                                    sx={{
                                        color: '#e0e0e0',
                                        fontSize: '1.1rem',
                                        '& .MuiFormControlLabel-label': {
                                            letterSpacing: 3, // You can adjust this value as needed
                                        },
                                    }}
                                />

                            </Grid>
                        ))}
                    </Grid>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            marginTop: 3,
                        }}
                    >
                        <Button
                            sx={{
                                backgroundColor: '#ff8c00',
                                color: '#fff',

                                padding: 1.5,
                                letterSpacing: 4,
                                borderRadius: '30px',
                                marginTop: 3,
                                '&:hover': { backgroundColor: '#ff6f00' },
                            }}
                            onClick={handleSubmit}
                        >
                            Save Changes
                        </Button>
                    </Box>
                </Box>
            ) : (
                <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                    <Grid item xs={12}>
                        <FormGroup>
                            {languages.map((language, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            value={language.name}
                                            onChange={handleCheckboxChange}
                                            checked={selectedLanguages.includes(language.name)}
                                            sx={{
                                                color: '#ffffff',
                                                '&.Mui-checked': { color: '#ff8c00' },
                                                '&:hover': { backgroundColor: 'rgba(255, 140, 0, 0.1)' },
                                            }}
                                        />
                                    }
                                    label={language.name}
                                    sx={{
                                        color: '#e0e0e0', fontSize: '1.1rem', '& .MuiFormControlLabel-label': {
                                            letterSpacing: 3, // You can adjust this value as needed
                                        },
                                    }}
                                />
                            ))}
                        </FormGroup>
                    </Grid>
                </Grid>
            )}

            {!submitted && (


                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        marginTop: 3,
                    }}
                >
                    <Button
                        sx={{
                            backgroundColor: '#ff8c00',
                            color: '#fff',

                            letterSpacing: 4,
                            padding: 1.5,
                            borderRadius: '30px',
                            marginTop: 3,
                            '&:hover': { backgroundColor: '#ff6f00' },
                        }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default LanguagesSelection;
